export function CountBadge({ n, testid }) {
  if (!n) return null;
  return (
    <span data-testid={testid} className="min-w-[18px] h-[18px] px-1 rounded-full bg-[#FF3B6B] text-white text-[10px] font-bold grid place-items-center leading-none">
      {n > 99 ? "99+" : n}
    </span>
  );
}
